/**
 * Primary line for plant titles in the Garden App. Prefer common name; if the
 * legacy handoff default "Plant" was stored, use botanical; else fall back.
 */
export function displayPrimaryPlantName(plant) {
  if (!plant) return 'Unnamed plant';
  const c = (plant.common_name && String(plant.common_name).trim()) || '';
  if (c && c.toLowerCase() !== 'plant') return c;
  if (c.toLowerCase() === 'plant') {
    const b = (plant.botanical_name && String(plant.botanical_name).trim()) || '';
    if (b) return b;
    return 'Unnamed plant';
  }
  const b = (plant.botanical_name && String(plant.botanical_name).trim()) || '';
  if (b) return b;
  return 'Unnamed plant';
}

/** Subtitle: botanical, hidden when it would duplicate the title line. */
export function displayBotanicalSubtitle(plant) {
  if (!plant) return null;
  const b = (plant.botanical_name && String(plant.botanical_name).trim()) || '';
  if (!b) return null;
  const primary = displayPrimaryPlantName(plant);
  if (primary && b && primary === b) return null;
  return b;
}
